var reviewSliders = document.querySelectorAll('.review-swiper');
var initReviewSlider = (item) => {
  let options = {
    navigation: {
      nextEl: item.parentElement.parentElement.parentElement.querySelector('.review-swiper-nav__next'),
      prevEl: item.parentElement.parentElement.parentElement.querySelector('.review-swiper-nav__prev'),
    },
    loop: false,
    speed: 500,
    observer: true,
    observeParents: true,
    iOSEdgeSwipeDetection: true,
    iOSEdgeSwipeThreshold: 0,
    simulateTouch: true,
    preventInteractionOnTransition: true,
    slidesPerView: 'auto',
    height: 'auto',
    centeredSlides: false,
    spaceBetween: 20,
    breakpoints: {
      992: {
        spaceBetween: 30,
      },
    },
  };

  var reviewSwiper = new Swiper(item, options);
};
reviewSliders.forEach((item, i) => {
  initReviewSlider(item);
});
